import { render } from "./c-score.vue?vue&type=template&id=26d2258d&scoped=true"
import script from "./c-score.vue?vue&type=script&lang=js"
export * from "./c-score.vue?vue&type=script&lang=js"

import "./c-score.vue?vue&type=style&index=0&id=26d2258d&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26d2258d"]])

export default __exports__